import { FacetRenderer } from "../renderable/Renderable";
import { AxesHelper } from "three";
import { modelPool, modelToAbsolutePath } from "@modules/model";
import { Matrix4, Quaternion, Vector3 } from "flavr-math";
const IDENTITY_SCALE = new Vector3(1, 1, 1);
const TEMP_MATRIX_1 = new Matrix4();
const TEMP_MATRIX_2 = new Matrix4();
const TEMP_POSITION = new Vector3();
const TEMP_ORIENTATION = new Quaternion();
const TEMP_SCALE = new Vector3();
export class AxisHelperRenderable extends FacetRenderer {
    destroy() {
        if (this.helper === undefined)
            return;
        this.owner.removeObjectFromScene(this.helper);
        this.helper.geometry.dispose();
        if (Array.isArray(this.helper.material)) {
            this.helper.material.forEach((material) => material.dispose());
        }
        else {
            this.helper.material.dispose();
        }
        this.helper = undefined;
    }
    setVisible(visible) {
        if (this.helper === undefined)
            return;
        this.helper.visible = visible;
    }
    updateFacet(facet) {
        if (this.helper === undefined || this.facet === undefined || this.facet.size !== facet.size) {
            if (this.helper !== undefined) {
                this.owner.removeObjectFromScene(this.helper);
            }
            this.helper = new AxesHelper(facet.size);
            const model = modelPool.getModelOrThrow(this.owner.modelUID);
            this.helper.name = model.getName();
            this.helper.userData = {
                path: modelToAbsolutePath(model)
            };
            this.owner.addObjectToScene(this.helper);
        }
    }
    updateTransform() {
        if (this.helper === undefined) {
            throw new Error("We expect this.helper to be defined.");
        }
        const facet = this.facet;
        if (facet === undefined) {
            throw new Error("We expect this.facet to be defined.");
        }
        const matrix = TEMP_MATRIX_1.compose(this.owner.worldPosition, this.owner.worldOrientation, facet.isScalable ? this.owner.worldScale : IDENTITY_SCALE);
        if (facet.offset !== undefined) {
            matrix.multiply(TEMP_MATRIX_2.copy(facet.offset));
        }
        matrix.decompose(TEMP_POSITION, TEMP_ORIENTATION, TEMP_SCALE);
        this.helper.position.copy(TEMP_POSITION);
        this.helper.quaternion.copy(TEMP_ORIENTATION);
        this.helper.scale.copy(TEMP_SCALE);
        this.helper.matrixWorldNeedsUpdate = true;
    }
}
